//@ts-check
import React from 'react';
import classNames from 'classnames';
import {bool, func, node, number, string} from 'prop-types';
// @ts-ignore
import styles from './Dialog2.scss';
import Icon from '../Icon';
import {ic_close as closeIcon} from 'react-icons-kit/md/ic_close';
import {ic_signal_cellular_4_bar as resizeIcon} from 'react-icons-kit/md/ic_signal_cellular_4_bar';
import useWindowSize from '../../util/hooks/useWindowSize';
import useUniqueId from '../../util/hooks/useUniqueId';

const strings = {
  close: 'close',
  closeCharacter: '⨉',
};

export const DialogHeading = ({children, id}) =>
  <h2 className={styles.DialogHeading} id={id}>{children}</h2>;
DialogHeading.propTypes = {
  children: string.isRequired,
  id: string,
};

const noop = () => {};

const DialogHeader = ({heading, hideX, onClose, headingId, headerClass}) => (
  <header className={classNames(styles.header, headerClass)}>
    {typeof heading === 'string' ? <DialogHeading id={headingId}>{heading}</DialogHeading> : <div id={headingId}>{heading}</div>}
    {!hideX && <button
      className={styles.closeButton}
      onClick={onClose}
      title={strings.close}><Icon icon={closeIcon} size={25} /></button>}
  </header>
);
DialogHeader.propTypes = {
  headerClass: string,
  heading: node.isRequired,
  hideX: bool,
  onClose: func.isRequired,
  headingId: string.isRequired,
};

const Dialog2 = ({
  heading,
  headerClass,
  contentClass,
  footerClass,
  isOpen,
  onClose,
  footer,
  hideX,
  children,
  width,
  height,
  closeOnClickOutside,
  resize,
  modal = true,
}) => {
  const {width: winWidth, height: winHeight} = useWindowSize();
  const left = Math.max(0, winWidth / 2 - width / 2);
  const top = Math.max(0, winHeight / 2 - height / 2);
  const headingId = useUniqueId();
  return (
    isOpen &&
      <div className={styles.Dialog2} onKeyDown={hideX ? noop : (event) => {
        if (event.key === 'Escape') onClose(event);
      }} tabIndex={0}>
        {modal && <div className={styles.overlay} onClick={closeOnClickOutside ? onClose : noop}></div>}
        <section className={styles.window} role="dialog" aria-labelledby={headingId} style={{
          left: `${left}px`,
          top: `${top}px`,
          width: `${width}px`,
          height: `${height}px`,
          ...(resize ? {resize: 'both'} : {}),
        }}>
          <DialogHeader
            heading={heading}
            headerClass={headerClass}
            headingId={headingId}
            hideX={hideX}
            onClose={onClose}
          />
          <div className={classNames(styles.content, contentClass)}>
            {children}
          </div>
          {resize && <Icon className={styles.resize} icon={resizeIcon} />}
          {footer && <footer className={classNames(styles.footer, footerClass)}>
            {footer}
          </footer>}
        </section>
      </div>
  );
};
Dialog2.propTypes = {
  headerClass: string,
  contentClass: string,
  footerClass: string,
  heading: node.isRequired,
  onClose: func.isRequired,
  footer: node,
  hideX: bool,
  children: node.isRequired,
  height: number,
  width: number,
  isOpen: bool,
  resize: bool,
  modal: bool,
  closeOnClickOutside: bool,
};

export default Dialog2;
